/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Alert } from '../model/alert';
import { ApiRequestDto } from '../model/apiRequestDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MedAlertService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Marks an alert as accepted
     * Sets the alert in the database as accepted.  Removes this alert from the active list.        Sample Call      http://URL/api/MedAlert/Accept/14ed864fa9574289b592bd0f05294ab3
     * @param id Id of the alert to accept
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medAlertAccept(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public medAlertAccept(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public medAlertAccept(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public medAlertAccept(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling medAlertAccept.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<any>(`${this.basePath}/api/MedAlert/Accept/${encodeURIComponent(String(id))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Marks an alert as do not send
     * Sets the alert in the database as do not send.  Removes this alert from the active list.        Sample Call      http://URL/api/MedAlert/DoNotSend/14ed864fa9574289b592bd0f05294ab3
     * @param id Id of the alert to accept
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medAlertDoNotSent(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public medAlertDoNotSent(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public medAlertDoNotSent(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public medAlertDoNotSent(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling medAlertDoNotSent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<any>(`${this.basePath}/api/MedAlert/DoNotSend/${encodeURIComponent(String(id))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Count of active medication alerts
     * Return the current count of active medication alerts this person can see based on the selected organizational units        Sample Call      http://URL/api/MedAlert/AlertCount
     * @param requestParameters Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medAlertGetActiveAlertCount(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public medAlertGetActiveAlertCount(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public medAlertGetActiveAlertCount(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public medAlertGetActiveAlertCount(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medAlertGetActiveAlertCount.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/MedAlert/AlertCount`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * All active medication alerts
     * All active alerts for the given facility list.  An alert is active if no action has been taken.        Sample Call      http://URL/api/MedAlert/ActiveMedAlerts
     * @param requestParameters Contains request parameters: orgList
     * @param threeDays Bool
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medAlertGetActiveMedAlerts(requestParameters: ApiRequestDto, threeDays?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Alert>;
    public medAlertGetActiveMedAlerts(requestParameters: ApiRequestDto, threeDays?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Alert>>;
    public medAlertGetActiveMedAlerts(requestParameters: ApiRequestDto, threeDays?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Alert>>;
    public medAlertGetActiveMedAlerts(requestParameters: ApiRequestDto, threeDays?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medAlertGetActiveMedAlerts.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (threeDays !== undefined && threeDays !== null) {
            queryParameters = queryParameters.set('threeDays', <any>threeDays);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Alert>(`${this.basePath}/api/MedAlert/ActiveMedAlerts`,
            requestParameters,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Historical Alerts Excel download
     * Receive list of sort and filter data to compile MedAlerts for Excel download        Sample Call  POST http://URL/api/MedAlert/UploadHistoryToExcel       body: {\&quot;Filters\&quot;:[],\&quot;Sorts\&quot;:[{\&quot;Direction\&quot;:\&quot;Asc\&quot;,\&quot;ColumnName\&quot;:\&quot;Medication\&quot;}],\&quot;PageNumber\&quot;:1,\&quot;PageSize\&quot;:10,\&quot;SearchTerm\&quot;:\&quot;\&quot;}
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medAlertGetMedAlertSortedHistory(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Alert>;
    public medAlertGetMedAlertSortedHistory(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Alert>>;
    public medAlertGetMedAlertSortedHistory(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Alert>>;
    public medAlertGetMedAlertSortedHistory(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medAlertGetMedAlertSortedHistory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Alert>(`${this.basePath}/api/MedAlert/UploadHistoryToExcel`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Historical Alerts
     * Shows all historical alerts that have had a action taken on them (ie accept, do not send, autoaccepted)        Sample Call      http://URL/api/MedAlert/MedAlertHistory
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param includeActive Include active orders in history results
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medAlertGetMedAlertsHistory(requestParameters: ApiRequestDto, includeActive: boolean, observe?: 'body', reportProgress?: boolean): Observable<Alert>;
    public medAlertGetMedAlertsHistory(requestParameters: ApiRequestDto, includeActive: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Alert>>;
    public medAlertGetMedAlertsHistory(requestParameters: ApiRequestDto, includeActive: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Alert>>;
    public medAlertGetMedAlertsHistory(requestParameters: ApiRequestDto, includeActive: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medAlertGetMedAlertsHistory.');
        }

        if (includeActive === null || includeActive === undefined) {
            throw new Error('Required parameter includeActive was null or undefined when calling medAlertGetMedAlertsHistory.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeActive !== undefined && includeActive !== null) {
            queryParameters = queryParameters.set('includeActive', <any>includeActive);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Alert>(`${this.basePath}/api/MedAlert/MedAlertHistory`,
            requestParameters,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
